'use client';

import type { TopSearchesProps } from '../types';
import { SearchIcon } from '../icons';
import { useClientConfig } from '@/lib/clients/ClientContext';

export default function TopSearches({ searches, onSearchClick }: TopSearchesProps) {
  const clientConfig = useClientConfig();
  if (searches.length === 0) return null;

  return (
    <div className="flex flex-col items-start gap-[6px] self-stretch py-4">
      <h4 className="text-sm font-medium font-gotham text-text-primary leading-[28px]">
        {clientConfig.ui.strings.topSearchesTitle}
      </h4>
      <ul className="flex flex-col self-stretch">
        {searches.map((search, idx) => (
          <li key={idx} className="h-8 flex items-center">
            <button
              onClick={() => onSearchClick(search)}
              className="flex items-center gap-[6px] text-sm font-gotham font-normal text-text-primary transition-colors hover:text-brand cursor-pointer"
            >
              {/* Figma: 16x16 search icon */}
              <SearchIcon className="w-4 h-4 flex-shrink-0" />
              <span className="leading-[14px]">{search}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
